export default __webpack_public_path__ + "static/media/panel-bg.4785e14b.webp";